import { render } from "./PoweredByRdx.vue?vue&type=template&id=c79c5e68"
const script = {}

import exportComponent from "/codebuild/output/src947608915/src/marketplace-landing-deprecated/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__